import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { marginBottomSpacing, getFontTokenStyle, getColorToken, spacing } from '@koaly/mixins';
import { withExtra } from '@koaly/with-extra';
import React from 'react';
import { up } from 'styled-breakpoints';
import styled, { css } from 'styled-components';
import { useLinkWrapper } from '../../hooks/useLinkWrapper.js';
import { Button } from '../Button/Button.js';
import { ButtonGroup } from '../Button/ButtonGroup/ButtonGroup.js';
import { Heading } from '../Heading/Heading.js';
import { Caption } from '../Media/Caption.js';
import { Paragraph } from '../Paragraph/Paragraph.js';

const StyledTitleContent = styled('article').withConfig({
    shouldForwardProp: (prop, defaultValidatorFn) => !['spacing', 'spaceAfter'].includes(prop),
}) `
  ${({ spaceAfter }) => spaceAfter && marginBottomSpacing(spaceAfter)};
  ${({ align }) => align && `text-align: ${align};`};
  ${({ spacing }) => spacing && css `
     padding: ${({ theme }) => theme.tokens.contentSectionMobilePaddingVertical} 0;
    ${up('s')} {
      padding: ${({ theme }) => theme.tokens.contentSectionSpacingVertical} 0;
    }
  `};
`;
const Subtitle = styled.span `
  display: inline-block;
  ${getFontTokenStyle('label', 'small', undefined, 'bold')};
  color: ${getColorToken('800', 'primary')};
  ${({ spaceAfter }) => spaceAfter && marginBottomSpacing(spaceAfter)};
`;
const StyledButton = styled(Button) `
  margin-right: ${spacing(6)};
  ${({ hasContentTop }) => hasContentTop && `margin-top: ${spacing(16)};`}
  &:last-child {
    margin-right: 0;
  }
`;
const StyleCaption = styled(Caption).attrs({ as: 'span' }) `
  display: block;
`;
const TitleContent = withExtra(({ title, titleAs, titleSize, description, buttons, variant, spaceAfter, subtitle, align, children, className, spacing, as, id, caption, titleSpaceAfter, }) => {
    const linkWrap = useLinkWrapper();
    return (React.createElement(StyledTitleContent, { id: id, className: className, align: align, spaceAfter: spaceAfter, spacing: spacing, as: as },
        subtitle && React.createElement(Subtitle, { spaceAfter: 8 }, subtitle),
        React.createElement(Heading, { as: titleAs, size: titleSize, variant: variant, spaceAfter: titleSpaceAfter ? titleSpaceAfter : description ? 8 : 16 }, title),
        description && (React.createElement(Paragraph, { variant: variant, spaceAfter: 16 }, description)),
        children,
        buttons && (React.createElement(ButtonGroup, { spacing: 4 }, buttons.map((_a, i) => {
            var { label, size } = _a, rest = __rest(_a, ["label", "size"]);
            return linkWrap(React.createElement(StyledButton, Object.assign({}, rest, { hasContentTop: children ? true : false, key: i + '-button-title-content', size: "medium", elevation: 2, spaceAfter: caption ? 8 : undefined }), label));
        }))),
        caption && React.createElement(StyleCaption, null, caption)));
}, { name: 'TitleContent' });

export { TitleContent };
//# sourceMappingURL=TitleContent.js.map
